/* KUZO — theme.js. Fără dependențe. */
(function () {
  'use strict';
  var K = window.KUZO || { routes: {}, strings: {}, money: '{{amount}} lei' };

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var fmt = K.money || '{{amount}}';
    var withComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
    var noDec = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, noDec)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec)
      .replace(/\{\{\s*amount\s*\}\}/, value);
  }

  /* Toast */
  var toast = document.getElementById('CartToast');
  var toastTimer;
  function showToast(text, isError) {
    if (!toast) return;
    toast.querySelector('.toast__text').textContent = text;
    toast.classList.toggle('toast--error', !!isError);
    toast.hidden = false;
    requestAnimationFrame(function () { toast.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
      setTimeout(function () { toast.hidden = true; }, 220);
    }, 3800);
  }

  /* Header */
  var header = document.querySelector('[data-header]');
  if (header && header.classList.contains('header--overlay')) {
    var onScroll = function () { header.classList.toggle('is-fixed', window.scrollY > 40); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
  var navToggle = document.querySelector('[data-nav-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  if (navToggle && mobileNav) {
    navToggle.addEventListener('click', function () {
      var open = navToggle.getAttribute('aria-expanded') === 'true';
      navToggle.setAttribute('aria-expanded', String(!open));
      mobileNav.hidden = open;
      if (header) header.classList.toggle('is-fixed', !open || window.scrollY > 40);
    });
  }
  var lang = document.querySelector('[data-lang-select]');
  if (lang) lang.addEventListener('change', function () { lang.form.submit(); });

  function updateCartCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('is-empty', n === 0);
    });
  }

  /* Cantitate +/- (produs și coș) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var wrap = btn.closest('.qty');
    var input = wrap && wrap.querySelector('[data-qty-input]');
    if (!input) return;
    var min = parseInt(input.min || '1', 10);
    var v = parseInt(input.value || '1', 10) + parseInt(btn.getAttribute('data-qty'), 10);
    if (isNaN(v) || v < min) v = min;
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Coș: actualizare automată la schimbarea cantității */
  var cartForm = document.querySelector('[data-cart-form]');
  if (cartForm) {
    var t;
    cartForm.addEventListener('change', function (e) {
      if (!e.target.matches('[data-line-qty]')) return;
      clearTimeout(t);
      t = setTimeout(function () { cartForm.submit(); }, 350);
    });
  }

  /* Sortare colecție */
  var sort = document.querySelector('[data-sort]');
  if (sort) sort.addEventListener('change', function () { sort.form.submit(); });

  /* Login: recuperare parolă */
  var rec = document.querySelector('[data-recover-toggle]');
  if (rec) rec.addEventListener('click', function (e) {
    e.preventDefault();
    var box = document.getElementById('recover');
    if (box) { box.hidden = !box.hidden; if (!box.hidden) box.querySelector('input').focus(); }
  });

  /* Produs */
  var productEl = document.querySelector('[data-product]');
  if (!productEl) return;

  var variantsEl = productEl.querySelector('[data-variants]');
  var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
  var form = productEl.querySelector('[data-product-form]');
  var idInput = productEl.querySelector('[data-variant-id]');
  var addBtn = productEl.querySelector('[data-add-button]');
  var addText = productEl.querySelector('[data-add-text]');
  var priceCur = productEl.querySelector('[data-price-current]');
  var priceCmp = productEl.querySelector('[data-price-compare]');
  var priceBox = productEl.querySelector('[data-price]');
  var sticky = productEl.querySelector('[data-sticky]');
  var stickyBtn = productEl.querySelector('[data-sticky-button]');
  var stickyPrice = productEl.querySelector('[data-sticky-price]');

  function selectedOptions() {
    var out = [];
    productEl.querySelectorAll('[data-option-index]').forEach(function (fs) {
      var checked = fs.querySelector('input:checked');
      out.push(checked ? checked.value : null);
    });
    return out;
  }
  function findVariant(opts) {
    return variants.find(function (v) {
      return v.options.every(function (o, i) { return o === opts[i]; });
    });
  }
  function markAvailability(opts) {
    productEl.querySelectorAll('[data-option-index]').forEach(function (fs, idx) {
      fs.querySelectorAll('input').forEach(function (inp) {
        var test = opts.slice();
        test[idx] = inp.value;
        var v = findVariant(test);
        var lbl = fs.querySelector('label[for="' + inp.id + '"]');
        if (lbl) lbl.classList.toggle('is-unavailable', !(v && v.available));
      });
    });
  }
  function showMedia(id) {
    if (!id) return;
    var slides = productEl.querySelectorAll('.gallery__slide');
    var found = false;
    slides.forEach(function (s) { if (String(s.getAttribute('data-media-id')) === String(id)) found = true; });
    if (!found) return;
    slides.forEach(function (s) {
      var on = String(s.getAttribute('data-media-id')) === String(id);
      s.hidden = !on; s.classList.toggle('is-active', on);
      var vid = s.querySelector('video'); if (vid && !on) vid.pause();
    });
    productEl.querySelectorAll('[data-thumb]').forEach(function (b) {
      var on = String(b.getAttribute('data-thumb')) === String(id);
      b.classList.toggle('is-active', on); b.setAttribute('aria-selected', on ? 'true' : 'false');
    });
  }
  function applyVariant(v) {
    if (!v) {
      if (addBtn) { addBtn.disabled = true; addText.textContent = K.strings.unavailable; }
      if (stickyBtn) { stickyBtn.disabled = true; stickyBtn.textContent = K.strings.unavailable; }
      return;
    }
    idInput.value = v.id;
    if (priceCur) priceCur.textContent = formatMoney(v.price);
    if (priceCmp) {
      var sale = v.compare_at_price && v.compare_at_price > v.price;
      priceCmp.hidden = !sale;
      if (sale) priceCmp.textContent = formatMoney(v.compare_at_price);
      if (priceBox) priceBox.classList.toggle('price--sale', !!sale);
    }
    if (stickyPrice) stickyPrice.textContent = formatMoney(v.price);
    var label = v.available ? K.strings.addToCart : K.strings.soldOut;
    if (addBtn) { addBtn.disabled = !v.available; addText.textContent = label; }
    if (stickyBtn) { stickyBtn.disabled = !v.available; stickyBtn.textContent = label; }
    if (v.featured_media) showMedia(v.featured_media.id);
    if (history.replaceState) {
      var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
      history.replaceState({}, '', url.toString());
    }
  }
  productEl.addEventListener('change', function (e) {
    if (!e.target.matches('[data-option]')) return;
    var opts = selectedOptions();
    markAvailability(opts);
    applyVariant(findVariant(opts));
  });
  if (variants.length && productEl.querySelector('[data-option-index]')) markAvailability(selectedOptions());

  productEl.querySelectorAll('[data-thumb]').forEach(function (b) {
    b.addEventListener('click', function () { showMedia(b.getAttribute('data-thumb')); });
  });

  /* Adaugă în coș (AJAX) */
  var busy = false;
  function addToCart() {
    if (busy || !form) return;
    var v = variants.find(function (x) { return String(x.id) === String(idInput.value); });
    if (v && !v.available) return;
    busy = true;
    if (addBtn) addBtn.setAttribute('aria-busy', 'true');
    var fd = new FormData(form);
    fetch(K.routes.cartAdd + '.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () { return fetch(K.routes.cartGet, { headers: { 'Accept': 'application/json' } }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        showToast(K.strings.added);
      })
      .catch(function (err) {
        var msg = K.strings.error;
        if (err && err.json) { err.json().then(function (j) { showToast(j.description || j.message || msg, true); }).catch(function () { showToast(msg, true); }); }
        else showToast(msg, true);
      })
      .finally(function () { busy = false; if (addBtn) addBtn.removeAttribute('aria-busy'); });
  }
  if (form) form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(); });
  if (stickyBtn) stickyBtn.addEventListener('click', addToCart);

  /* Bară fixă pe mobil când butonul principal iese din ecran */
  if (sticky && addBtn && 'IntersectionObserver' in window) {
    sticky.hidden = false;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var below = en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', !en.isIntersecting && below);
      });
    }, { threshold: 0 });
    io.observe(addBtn);
  }
})();
